(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tiendas"] && !Shopify.designMode) return;
  try {
    
(function () {
  // === CONFIGURACIÓN ===
  const DOMINIO_PERU = "unnostore.com";
  const DOMINIO_CHILE = "unnounderwear.cl";
  
  // Usamos sessionStorage para que si el usuario cierra el popup, 
  // no le vuelva a molestar mientras tenga el navegador abierto.
  const STORAGE_KEY = "geo_popup_closed"; 

  if (sessionStorage.getItem(STORAGE_KEY)) return;

  // === FUNCIONES ===
  
  // 1. Detectar País (Usa 2 servicios para asegurar que funcione)
  async function detectCountry() {
    try {
      // Intento 1: ipapi.co
      const r1 = await fetch("https://ipapi.co/json/");
      if (r1.ok) {
        const data = await r1.json();
        return data.country; // Retorna 'CL', 'PE', etc.
      }
    } catch (e) {
      // Silencioso
    }

    try {
      // Intento 2: country.is (Respaldo)
      const r2 = await fetch("https://api.country.is");
      if (r2.ok) {
        const data = await r2.json();
        return data.country;
      }
    } catch (e) {
      return null;
    }
    return null;
  }

  // 2. Mostrar el Popup
  function showRedirectModal(countryName, redirectUrl) {
    // Estilos CSS inyectados
    const style = document.createElement("style");
    style.textContent = `
      .geo-overlay { position: fixed; inset: 0; display: grid; place-items: center; background: rgba(0,0,0,0.7); z-index: 999999; backdrop-filter: blur(2px); }
      .geo-modal { width: 90%; max-width: 480px; background: #fff; border-radius: 12px; padding: 30px; box-shadow: 0 10px 40px rgba(0,0,0,0.4); text-align: center; font-family: 'Roboto', sans-serif; animation: geo-fade 0.3s ease-out; }
      .geo-title { font-size: 20px; font-weight: 700; color: #2073a0; margin: 0 0 15px 0; }
      .geo-body { font-size: 15px; color: #444; margin-bottom: 25px; line-height: 1.5; }
      .geo-actions { display: flex; flex-direction: column; gap: 10px; }
      .geo-btn { border: 0; border-radius: 50px; padding: 12px 20px; cursor: pointer; font-weight: 600; font-size: 14px; transition: 0.2s; width: 100%; }
      .geo-primary { background: #2073a0; color: #fff; }
      .geo-primary:hover { background: #165275; }
      .geo-secondary { background: #f0f0f0; color: #555; }
      .geo-secondary:hover { background: #e0e0e0; }
      @keyframes geo-fade { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
    `;
    document.head.appendChild(style);

    // HTML del Modal
    const overlay = document.createElement("div");
    overlay.className = "geo-overlay";
    
    const modal = document.createElement("div");
    modal.className = "geo-modal";
    modal.innerHTML = `
      <h2 class="geo-title">¿Estás en ${countryName}?</h2>
      <div class="geo-body">
        Hemos detectado que nos visitas desde <b>${countryName}</b>. <br>
        Para ver precios en tu moneda y envíos locales, te recomendamos ir a nuestra tienda exclusiva.
      </div>
      <div class="geo-actions">
        <button class="geo-btn geo-primary" id="geo-go">Ir a la tienda de ${countryName}</button>
        <button class="geo-btn geo-secondary" id="geo-stay">Quedarme aquí</button>
      </div>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // Eventos
    const closeModal = () => {
      overlay.remove();
      sessionStorage.setItem(STORAGE_KEY, "true"); // No volver a mostrar en esta sesión
    };

    modal.querySelector("#geo-go").addEventListener("click", () => {
      window.location.href = redirectUrl;
    });
    
    modal.querySelector("#geo-stay").addEventListener("click", closeModal);
    overlay.addEventListener("click", (e) => { if(e.target === overlay) closeModal(); });
  }

  // === EJECUCIÓN PRINCIPAL ===
  (async function init() {
    const country = await detectCountry();
    const hostname = window.location.hostname;

    if (!country) return; // Si falla la detección, no hacemos nada.

    // CASO 1: Usuario en CHILE (CL) pero viendo web de PERÚ
    if (country === "CL" && (hostname === DOMINIO_PERU || hostname.endsWith(DOMINIO_PERU))) {
      showRedirectModal("Chile", `https://${DOMINIO_CHILE}`);
    } 
    // CASO 2: Usuario en PERÚ (PE) pero viendo web de CHILE
    else if (country === "PE" && (hostname === DOMINIO_CHILE || hostname.endsWith(DOMINIO_CHILE))) {
      showRedirectModal("Perú", `https://${DOMINIO_PERU}`);
    }
  })();

})();

  } catch(e) { console.error(e); }
})();
})();
